// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getDatabase } from 'firebase/database'; // ✅ Realtime Database

const firebaseConfig = {
  apiKey: "AIzaSyAob2AH2zyBGQBzWwRNSjbE7UMojwIZY6Q",
  authDomain: "alleygames-bc7a7.firebaseapp.com",
  databaseURL: "https://alleygames-bc7a7-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "alleygames-bc7a7",
  storageBucket: "alleygames-bc7a7.appspot.com",
  messagingSenderId: "383450791217",
  appId: "1:383450791217:web:50c676e64c5c4f53c44410"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
// export const db = getFirestore(app);           // Firestore
export const rtdb = getDatabase(app);          // ✅ Realtime Database
export const storage = getStorage(app);
export { firebaseConfig };
export default app;
